export default __webpack_public_path__ + "static/media/boutique.26adb8fb.jpg";